import { ApplicationStatus } from "./workflow-application";

export class CloseApplicationRequest {
  requestedStatus: ApplicationStatus = ApplicationStatus.Voided;
  reason: string;
  user: string;
  dateTime: Date;

  constructor(options?: Partial<CloseApplicationRequest>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class BulkCloseApplicationRequest extends CloseApplicationRequest {
  applicationIds: string[];

  constructor(options?: Partial<BulkCloseApplicationRequest>) {
    super();
    if (options) {
      Object.assign(this, options);
    }
  }
}
